import { inject, provideAppInitializer } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { MaintenanceService } from '../../pages/maintenance/maintenance.service'

export async function runMaintenanceCheck(maintenanceService: MaintenanceService) {
	try {
		const response = await firstValueFrom(maintenanceService.fetchMaintenanceStatus())
		if (response.status === 'ok') {
			const result = response.result[0]
			if (result && result.ON_MAINTENANCE !== 'NO') maintenanceService.redirectToMaintenance()
		}
	} catch (error) {
		console.error('Error fetching maintenance mode status:', error)
		maintenanceService.redirectToMaintenance()
	}
}

export function initializeMaintenance(): () => Promise<void> {
	const coreService = inject(MaintenanceService)
	return () => runMaintenanceCheck(coreService)
}

export const provideMaintenance = () =>
	provideAppInitializer(() => {
		const initializerFn = initializeMaintenance()
		return initializerFn()
	})
